import { CSSProgressiveCaption01Semibold } from "@caisy/league";
import styled from "styled-components";

export const SOnboardingAssetFieldLabel = styled.div`
  ${CSSProgressiveCaption01Semibold};
  color: var(--text-04);
`;
